import MobileSliderPagesHeader from '../../components/MobileSliderPagesHeader';
import { useLangContext } from '../../../../../providers/LangProvider/LangProviderContext';
import { MobileSliderPagesContentStyled } from '../../components/styled/MobileSliderPagesStyled';
import SettingsDeleteProfile from '../../../../../modules/Settings/SettingsDeleteProfile/SettingsDeleteProfile';

function SlideDeleteProfile() {
    const { getLangPath } = useLangContext();

    return <>
        <MobileSliderPagesHeader goBack>
            <>{getLangPath('settings.delete_profile.title')}</>
        </MobileSliderPagesHeader>
        <MobileSliderPagesContentStyled className={'pb-3'}>
            <SettingsDeleteProfile/>
        </MobileSliderPagesContentStyled>
    </>
}

export default SlideDeleteProfile;
